import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Text: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M17 6.1H3' }],
    ['path', { d: 'M21 12.1H3' }],
    ['path', { d: 'M15.1 18H3' }],
  ],
];

export default Text;
